export default __webpack_public_path__ + "static/media/whatsapp.576d77cf.svg";